/**
 * Plain SVG icons for admin artist modal (and related admin UI).
 * Avoids lucide-react in hot paths so minifiers / Safari never see an undefined `Clock`-style binding.
 * Paths mirror lucide-react v0.285.0 (ISC).
 */
import React from 'react';

const svgAttrs = (className, rest) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  className,
  'aria-hidden': true,
  ...rest,
});

export function Radio(props) {
  const { className, ...rest } = props;
  return (
    <svg {...svgAttrs(className, rest)}>
      <path d="M4.9 19.1C1 15.2 1 8.8 4.9 4.9" />
      <path d="M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5" />
      <circle cx="12" cy="12" r="2" />
      <path d="M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5" />
      <path d="M19.1 4.9C23 8.8 23 15.1 19.1 19" />
    </svg>
  );
}

export function Edit(props) {
  const { className, ...rest } = props;
  return (
    <svg {...svgAttrs(className, rest)}>
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
      <path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4Z" />
    </svg>
  );
}

export function Trash2(props) {
  const { className, ...rest } = props;
  return (
    <svg {...svgAttrs(className, rest)}>
      <path d="M3 6h18" />
      <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
      <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
      <line x1="10" x2="10" y1="11" y2="17" />
      <line x1="14" x2="14" y1="11" y2="17" />
    </svg>
  );
}

export function Globe(props) {
  const { className, ...rest } = props;
  return (
    <svg {...svgAttrs(className, rest)}>
      <circle cx="12" cy="12" r="10" />
      <line x1="2" x2="22" y1="12" y2="12" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  );
}

export function ChevronUp(props) {
  const { className, ...rest } = props;
  return (
    <svg {...svgAttrs(className, rest)}>
      <path d="m18 15-6-6-6 6" />
    </svg>
  );
}

export function ChevronDown(props) {
  const { className, ...rest } = props;
  return (
    <svg {...svgAttrs(className, rest)}>
      <path d="m6 9 6 6 6-6" />
    </svg>
  );
}

export function QrCode(props) {
  const { className, ...rest } = props;
  return (
    <svg {...svgAttrs(className, rest)}>
      <rect width="5" height="5" x="3" y="3" rx="1" />
      <rect width="5" height="5" x="16" y="3" rx="1" />
      <rect width="5" height="5" x="3" y="16" rx="1" />
      <path d="M21 16h-3a2 2 0 0 0-2 2v3" />
      <path d="M21 21v.01" />
      <path d="M12 7v3a2 2 0 0 1-2 2H7" />
      <path d="M3 12h.01" />
      <path d="M12 3h.01" />
      <path d="M12 16v.01" />
      <path d="M16 12h1" />
      <path d="M21 12v.01" />
      <path d="M12 21v-1" />
    </svg>
  );
}

export function Download(props) {
  const { className, ...rest } = props;
  return (
    <svg {...svgAttrs(className, rest)}>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" x2="12" y1="15" y2="3" />
    </svg>
  );
}

export function ExternalLink(props) {
  const { className, ...rest } = props;
  return (
    <svg {...svgAttrs(className, rest)}>
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
      <polyline points="15 3 21 3 21 9" />
      <line x1="10" x2="21" y1="14" y2="3" />
    </svg>
  );
}

export function DollarSign(props) {
  const { className, ...rest } = props;
  return (
    <svg {...svgAttrs(className, rest)}>
      <line x1="12" x2="12" y1="2" y2="22" />
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
    </svg>
  );
}

export function TrendingUp(props) {
  const { className, ...rest } = props;
  return (
    <svg {...svgAttrs(className, rest)}>
      <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
      <polyline points="16 7 22 7 22 13" />
    </svg>
  );
}

export function Wallet(props) {
  const { className, ...rest } = props;
  return (
    <svg {...svgAttrs(className, rest)}>
      <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" />
      <path d="M3 5v14a2 2 0 0 0 2 2h16v-5" />
      <path d="M18 12a2 2 0 0 0 0 4h4v-4Z" />
    </svg>
  );
}

export function CreditCard(props) {
  const { className, ...rest } = props;
  return (
    <svg {...svgAttrs(className, rest)}>
      <rect width="20" height="14" x="2" y="5" rx="2" ry="2" />
      <line x1="2" x2="22" y1="10" y2="10" />
    </svg>
  );
}

export function Calendar(props) {
  const { className, ...rest } = props;
  return (
    <svg {...svgAttrs(className, rest)}>
      <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
      <line x1="16" x2="16" y1="2" y2="6" />
      <line x1="8" x2="8" y1="2" y2="6" />
      <line x1="3" x2="21" y1="10" y2="10" />
    </svg>
  );
}

export function History(props) {
  const { className, ...rest } = props;
  return (
    <svg {...svgAttrs(className, rest)}>
      <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
      <path d="M3 3v5h5" />
      <path d="M12 7v5l4 2" />
    </svg>
  );
}

/** Clock face — use this instead of lucide `Clock` on admin pages (no `Clock` identifier in scope). */
export function AdminClockIcon(props) {
  const { className, ...rest } = props;
  return (
    <svg {...svgAttrs(className, rest)}>
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  );
}
